export default __webpack_public_path__ + "static/media/Restriction_Enzyme_HaeIII_RE.21a41b56.svg";